import { render, staticRenderFns } from "./PropertyInstructionList.vue?vue&type=template&id=0f516b61&"
import script from "./PropertyInstructionList.vue?vue&type=script&lang=js&"
export * from "./PropertyInstructionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
installComponents(component, {VList})
